import { render, staticRenderFns } from "./CupboardEditDialog.vue?vue&type=template&id=60341e5d&scoped=true&"
import script from "./CupboardEditDialog.vue?vue&type=script&lang=js&"
export * from "./CupboardEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./CupboardEditDialog.vue?vue&type=style&index=0&id=60341e5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60341e5d",
  null
  
)

export default component.exports